module.exports = __webpack_public_path__ + "static/img/voice3.26d7e727.png";